import React, {Component} from "react";
import './App.css';

// Using PROPS for skill name
const ListSkill = (props)=>{
  return (
    <li>{props.list}</li>
  );
};
class Skill extends Component {
  render() {
    return (
      <div className="skillsChild">
          <h2>03_SKILLS</h2>
          <p>
            <ListSkill list="Leadership" />
            <ListSkill list="Time Management" />
            <ListSkill list="Communication" />
            <ListSkill list="Copywriting" />
            <li>Programming:
              <br /><b>(CSS3,HTML5,JavaScript,React
              <br />Knowing in: SASS,Bootstrap4,Github)</b>
            </li>
            </p>
          
          <div className="expChild">
            <h2>04_EXPERIENCE</h2>
            <p>
              <li>
                <b>Assistant Restaurant Manager</b>
                <br />PT Sriboga Marugame Indonesia
                <br />( 2017 - 2018 )
              </li>
              <br />
              <li>
                <b>Receiptionist</b>
                <br />PT JobStreet.com Indonesia
                <br />( 2017 )
              </li>
              </p>
          </div>
        </div>
    );
  };
};

export default Skill